var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{staticStyle:{"width":"100%","height":"400px"},attrs:{"center":_vm.center,"zoom":17}},[_c('GmapMarker',{attrs:{"position":this.center,"clickable":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }